import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar} from 'shared/components';
import CandidateRater from './CandidateRater';
import EntryRightMenu from './EntryRightMenu';

const RatingEntry = ({entry, detailsState}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.user} size='sm'/>
      <div className='flex-1'>
        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-2'>
              <div className='h3 medium'>
                <FormattedMessage id='recruiting.hiring_funnel.Rating'/>
              </div>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
            <div className='h5 jumbo'>{entry.name}</div>
          </div>
          <EntryRightMenu detailsState={detailsState} entry={entry}/>
        </div>
        <div className='pt2'>
          {entry.score ?
            <CandidateRater score={entry.score}/> :
            <FormattedMessage id='recruiting.hiring_funnel.Removed a rating'/>
          }
        </div>
      </div>
    </div>
  );
};

export default observer(RatingEntry);
